export const convertGrapeJSToDjangoTemlate = async(html: string) => {
  html = html.replace(/<!--([\s\S]*?)-->/g, '$1');
  return html
}